<template>
  <div id="app" class="container-fluid p-0">
    <component :is="layout">
      <router-view @isLoading="showLoading" />
    </component>
    <loading-spinner v-if="isLoading"></loading-spinner>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/LoadingSpinner";

const defaultLayout = "default";

export default {
  name: "app",
  components: {
    "loading-spinner": LoadingSpinner
  },
  data() {
    return {
      isLoading: false
    };
  },
  computed: {
    layout() {
      let layout = `${this.$route.meta.layout || defaultLayout}-layout`;
      return layout;
    }
  },
  methods: {
    showLoading(val) {
      if (typeof val != "undefined") {
        this.isLoading = val;
      }
    }
  }
};
</script>
